import { combineReducers } from 'redux';
import checkout from './checkout';

export default combineReducers({
  checkout,
});
